import React, { useState } from 'react';
import { 
  Text, 
  styled, 
  Container, 
  ContainerGutter, 
  ContainerWrap, 
  TextAppearance 
} from '@volkswagen-onehub/components-core';
import { SuggestModelo } from 'src/components';


interface FechaCompraProps {
  notALayer: boolean;
}

const Wrapper = styled.div<FechaCompraProps>`
  margin-top: 44px;
  @media screen and (min-width: 960px) {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
  }
`;
const MarginTop = styled.div`
  margin-top: 44px;
  @media all and (min-width: 960px) {
    margin-top: 0;
  }
`;

export const PantallaOtrosModelos = () => {

  const [inputValueOne, setInputValueOne] = useState('');
  const [inputValueTwo, setInputValueTwo] = useState('');

  const handleChangeOne = (e: any) => {
    setInputValueOne(e.target.value);
  };
  const handleChangeTwo = (e: any) => {
    setInputValueTwo(e.target.value);
  };


  return (
    <Wrapper notALayer={true}>
      <Container gutter={ContainerGutter.static200} wrap={ContainerWrap.always}>
        <div>
          <Text appearance={TextAppearance.copy0200} staticSize>Dudo entre este modelo<sup>*</sup>:</Text>
        </div>
        <SuggestModelo notALayer={true} marginTop='0' fieldsName='modeloUno'required={true}/>
      </Container>
      <Container gutter={ContainerGutter.static200} wrap={ContainerWrap.always}>
        <MarginTop>
          <Text appearance={TextAppearance.copy0200} staticSize>Y este otro:</Text>
        </MarginTop>
        <SuggestModelo notALayer={true} marginTop='0' fieldsName='modeloDos' required={false}/>
      </Container>
    </Wrapper>
  );
};
